export default {
  // Header
  "cs.header.badge": "CyberSOC 24/7",
  "cs.header.back": "Back",
  "cs.header.active": "SOC Active 24/7",

  // Hero slides
  "cs.hero.slide1.tag": "Operations Center",
  "cs.hero.slide1.title": "The Digital Shield of",
  "cs.hero.slide1.highlight": "your Business",
  "cs.hero.slide1.subtitle": "Our CyberSOC operates 24/7/365 with certified analysts, cutting-edge technology and internationally validated processes to protect your organization.",
  "cs.hero.slide1.cta": "View Live Dashboard",

  "cs.hero.slide2.tag": "Threat Intelligence",
  "cs.hero.slide2.title": "Proactive Intelligence",
  "cs.hero.slide2.highlight": "against Threats",
  "cs.hero.slide2.subtitle": "We monitor the dark web, underground forums and global OSINT sources to anticipate targeted attacks hours or days before they occur.",
  "cs.hero.slide2.cta": "Learn more",

  "cs.hero.slide3.tag": "Incident Response",
  "cs.hero.slide3.title": "Response in",
  "cs.hero.slide3.highlight": "Under 5 Minutes",
  "cs.hero.slide3.subtitle": "Automated playbooks and active response teams ready to contain and neutralize incidents in record time with zero downtime.",
  "cs.hero.slide3.cta": "View capabilities",

  "cs.hero.panel.title": "Live SOC Status",
  "cs.hero.panel.threats": "Threats detected",
  "cs.hero.panel.blocked": "Incidents blocked",
  "cs.hero.panel.response": "Response time",
  "cs.hero.panel.uptime": "SOC uptime",

  "cs.hero.backHome": "Back to Home",

  // Dashboard
  "cs.dashboard.tag": "Real-time Monitoring",
  "cs.dashboard.title": "CyberSOC",
  "cs.dashboard.highlight": "Dashboard",
  "cs.dashboard.subtitle": "Real-time operational metrics from our active 24/7 security centers",

  "cs.dashboard.m1.label": "Threats detected today",
  "cs.dashboard.m2.label": "Incidents blocked",
  "cs.dashboard.m3.label": "Monitored endpoints",
  "cs.dashboard.m4.label": "Response time",

  "cs.dashboard.radar.title": "Threat Radar",
  "cs.dashboard.radar.active": "Active",
  "cs.dashboard.radar.critical": "Critical",
  "cs.dashboard.radar.high": "High",
  "cs.dashboard.radar.medium": "Medium",

  "cs.dashboard.feed.title": "Live Threat Feed",
  "cs.dashboard.feed.updating": "Updating every 2s",

  // Features
  "cs.features.tag": "Services",
  "cs.features.title": "CyberSOC",
  "cs.features.highlight": "Capabilities",
  "cs.features.subtitle": "A world-class operations center with cutting-edge technology and certified processes",

  "cs.features.f1.title": "24/7 Detection",
  "cs.features.f1.desc": "Continuous infrastructure monitoring with sensors distributed across multiple network, endpoint and cloud layers.",
  "cs.features.f1.stat": "99.97%",
  "cs.features.f1.statLabel": "SOC Uptime",

  "cs.features.f2.title": "Incident Response",
  "cs.features.f2.desc": "Response teams ready to act in under 5 minutes with established protocols and automated playbooks.",
  "cs.features.f2.stat": "< 5 min",
  "cs.features.f2.statLabel": "Avg MTTR",

  "cs.features.f3.title": "Threat Hunting",
  "cs.features.f3.desc": "Proactive search for advanced threats that evade traditional detection using behavior analysis and ML.",
  "cs.features.f3.stat": "+200",
  "cs.features.f3.statLabel": "Daily IoCs",

  "cs.features.f4.title": "Cyber Intelligence",
  "cs.features.f4.desc": "Dark web, hacker forum and intelligence source monitoring to anticipate attacks targeting your industry.",
  "cs.features.f4.stat": "5 Countries",
  "cs.features.f4.statLabel": "OSINT Sources",

  "cs.features.f5.title": "Endpoint Detection",
  "cs.features.f5.desc": "Advanced EDR/XDR with event correlation, remote forensic analysis and automatic threat containment.",
  "cs.features.f5.stat": "12K+",
  "cs.features.f5.statLabel": "Endpoints",

  "cs.features.f6.title": "Cloud Security",
  "cs.features.f6.desc": "Continuous protection of workloads in AWS, Azure and GCP with insecure configuration detection.",
  "cs.features.f6.stat": "Multi-Cloud",
  "cs.features.f6.statLabel": "Coverage",

  // How we work
  "cs.process.tag": "Methodology",
  "cs.process.title": "How we",
  "cs.process.highlight": "work",
  "cs.process.subtitle": "A proven, audited response process designed to detect, contain and neutralize threats in the shortest possible time.",
  "cs.process.step1.title": "Onboarding & assessment",
  "cs.process.step1.desc": "We assess your infrastructure, inventory critical assets and deploy the SOC sensors across your environment.",
  "cs.process.step1.meta": "Days 1-3",
  "cs.process.step2.title": "Continuous 24/7 monitoring",
  "cs.process.step2.desc": "We watch network, endpoint, cloud and identity events with intelligent correlation 365 days a year.",
  "cs.process.step2.meta": "24/7/365",
  "cs.process.step3.title": "Detection & analysis",
  "cs.process.step3.desc": "Certified analysts validate every alert, rule out false positives and classify the real risk level.",
  "cs.process.step3.meta": "MTTD < 1 min",
  "cs.process.step4.title": "Response & containment",
  "cs.process.step4.desc": "We trigger automated playbooks and isolate the threat before it impacts your operations.",
  "cs.process.step4.meta": "MTTR < 5 min",
  "cs.process.step5.title": "Reporting & improvement",
  "cs.process.step5.desc": "We deliver executive and technical reports with hardening actions to strengthen your security posture.",
  "cs.process.step5.meta": "Weekly reports",
  "cs.process.step1.statUnit": "days",
  "cs.process.step2.statUnit": "days/year",
  "cs.process.step3.statUnit": "sec (MTTD)",
  "cs.process.step4.statUnit": "min (MTTR)",
  "cs.process.step5.statUnit": "reports/year",

  // Center / Facilities
  "cs.centro.tag": "Our center",
  "cs.centro.title": "World-class facilities for",
  "cs.centro.highlight": "cybersecurity",
  "cs.centro.subtitle": "Designed for protection, research and training: an ecosystem where technology, human talent and proven methodology converge.",
  "cs.centro.cta": "Explore capabilities",
  "cs.centro.detail": "View expanded detail",
  "cs.centro.modal.features": "Key capabilities",
  "cs.centro.modal.close": "Close",
  "cs.centro.modal.ctaPrimary": "View capabilities",
  "cs.centro.modal.ctaSecondary": "Talk to an expert",

  // CTA
  "cs.cta.tag": "Activate Protection",
  "cs.cta.title": "Protect your company with",
  "cs.cta.subtitle": "A team of over 200 certified specialists ready to defend your organization right now",
  "cs.cta.button": "Request free assessment",
  "cs.cta.homeButton": "View main site",
};